/* eslint-disable react/no-danger */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal, Header, Button, Segment } from 'semantic-ui-react';

class AlertBox extends PureComponent {
  static propTypes = {
    header: PropTypes.string,
    content: PropTypes.any,
    buttonText: PropTypes.string,
    type: PropTypes.string,
    open: PropTypes.bool,
    propagateClosure: PropTypes.func,
  }

  static defaultProps = {
    header: 'Alerte',
    content: '',
    buttonText: 'OK',
    type: null,
    open: false,
    propagateClosure: () => null,
  }

  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleEscape, false);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open && !this.state.open) {
      this.setState({ open: true });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleEscape, false);
  }

  handleEscape = (e) => {
    if (e.keyCode === 27 && this.state.open) {
      this.handleClose();
    }
  }

  handleClose = () => {
    this.props.propagateClosure();
    this.setState({ open: false });
  }

  render() {
    let icon;
    switch (this.props.type) {
      case 'error':
        icon = 'red warning sign';
        break;
      case 'success':
        icon = 'green checkmark';
        break;
      default:
        icon = 'blue info circle';
    }

    return (
      <Modal
        open={this.state.open}
        // basic
        // dimmer="blurring"
        size="tiny"
      >
        <Header icon={{ className: icon }} content={this.props.header} />
        <Modal.Content>
          <Segment basic textAlign="center">
            {typeof this.props.content === 'string'
              ? (
                <p dangerouslySetInnerHTML={{ __html: this.props.content }} />
              ) : this.props.content}
          </Segment>
        </Modal.Content>
        <Modal.Actions>
          <Button color="blue" onClick={this.handleClose} inverted>
            {this.props.buttonText}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default AlertBox;



// WEBPACK FOOTER //
// ./src/components/Modals/AlertBox.js